import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Link } from "react-router-dom";
import TourGuide from "../TourGuide";
import { useTheme } from "../../Context/ThemeContext";

// component to render plan information on sidebar
const DomainPlanInfo = () => {

    // Redux Data
    const currentWebsitePlanStatus = useSelector((store: StoreProptypes) => store.currentWebsitePlanStatus);
    const user = useSelector((store: StoreProptypes) => store.user);
    const { websites,  currentWebsite } = useSelector((store: StoreProptypes) => store);
    const dataPermission = websites?.filter((i: any) => i?.website_domain === currentWebsite?.domain)
    const paymentSettings = dataPermission && dataPermission[0]?.permissions?.find((i: any) => i?.name === "dashboard");
    const { t } = useTranslation();
    const { theme } = useTheme()

    return (
        <>
        <TourGuide />
            {user && user.department === 4 // check if partner user
            ? (
                <>
                {(user?.parent_id !== 0 &&  user?.parent_id !== 1) && paymentSettings?.name !== "dashboard" ? (
                    ""
                ) : <Link to="/front" className="aioa_dashboard-plan-info partner-dashboard-btn tour-plan-type">
                        <div className="nav-link-icon"><i className="material-symbols-outlined" aria-hidden="true">dashboard</i></div>
                        <div className="nav-link-text">{t("Partner Dashboard")}</div>
                    </Link>}
                </>
            ) : (
                <>
                    {currentWebsitePlanStatus && (
                        <div className="tour-plan-type">
                            {currentWebsitePlanStatus.isExpired ? (
                                <>
                                    <div className="aioa_dashboard-plan-info border-danger">
                                        <strong className="text-danger">{t("Expired Plan Label")}</strong>: {currentWebsitePlanStatus.planName}
                                    </div>
                                </>
                            ) : (currentWebsitePlanStatus.isTrial) ? (
                                <>
                                    <div className="aioa_dashboard-plan-info border-warning">
                                        <strong className="text-warning">{t("Trial Plan Label")}</strong>: {currentWebsitePlanStatus.planName}
                                    </div>
                                </>
                            ) : (currentWebsitePlanStatus.isCanceledPlan) ? (
                                <>
                                    <div className="aioa_dashboard-plan-info border-dark">
                                        <strong className={`${theme === 'dark' ? "text-white" : "text-dark" }`}>{t("Canceled Plan")}</strong>: {currentWebsitePlanStatus.planName}
                                    </div>
                                </>
                            ) : (currentWebsitePlanStatus.isInit || currentWebsitePlanStatus.isProPlan) ? (
                                <>
                                    <div className="aioa_dashboard-plan-info border-primary">
                                        <strong className="text-primary">{t("Your Plan Label")}</strong>: {currentWebsitePlanStatus.planName}
                                    </div>
                                </>
                            ) : (currentWebsitePlanStatus.isFreeWidget) ? (
                                <>
                                    <div className="aioa_dashboard-plan-info border-primary">
                                        <strong className="text-primary">{t("Your Plan Label")}</strong>: {currentWebsitePlanStatus.planName}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="aioa_dashboard-plan-info border-danger">
                                        <strong className="text-danger">{t("No Plan Found")}</strong>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </>
            )}
        </>
    )
}

export default DomainPlanInfo;